
document.addEventListener('cart:update', function(event) {
  if (event.detail && event.detail.cart) document.querySelectorAll('[data-f4-cart-count]').forEach(function(el) { el.textContent = event.detail.cart.item_count; });
});
if (location.pathname.replace(/\/$/, '').endsWith('/cart')) {
  const main = document.querySelector('main');
  let refreshTimer;
  if (main) new MutationObserver(function() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async function() {
      const cartLink = document.querySelector('.f4-cart-link');
      if (!cartLink) return;
      try {
        const response = await fetch(cartLink.getAttribute('href') + '.js', {headers:{Accept:'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('[data-f4-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
      } catch {}
    }, 200);
  }).observe(main, {childList:true,subtree:true});
}
document.addEventListener('click', function(event) {
  document.querySelectorAll('.f4-mobile-menu[open]').forEach(function(menu) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.f4-mobile-menu[open]').forEach(function(menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); });
});


function initializePurchaseBar() {
  const bar=document.querySelector('f4-sticky');
  const actions=document.querySelector('.f4-pdp-actions');
  const source=document.querySelector('[data-add]');
  const button=bar?.querySelector('button');
  if(!bar || !actions || !source || !button) return;
  const update=()=>{bar.classList.toggle('is-visible',actions.getBoundingClientRect().bottom<0);button.disabled=source.disabled;};
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  document.addEventListener('f4:variant',event=>{button.disabled=!event.detail.available||event.detail.busy;bar.querySelector('[data-sticky-price]').textContent=event.detail.price||'';button.textContent=event.detail.busy?'Adding…':event.detail.available?'Add to bag':'Unavailable';});
  button.addEventListener('click',()=>source.click());
  update();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initializePurchaseBar,{once:true});
else initializePurchaseBar();

